import "../../../../content/projects/dron/dron.css";
import * as React from 'react';
export default {
  React
};